import { render } from "./Dismissal.vue?vue&type=template&id=69a5e6d6&scoped=true"
import script from "./Dismissal.vue?vue&type=script&lang=js"
export * from "./Dismissal.vue?vue&type=script&lang=js"

import "./Dismissal.vue?vue&type=style&index=0&id=69a5e6d6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69a5e6d6"]])

export default __exports__